import React from "react";
import { SectionProps } from "../../App";
import { staffGroups } from "../../data/staff";
import { StaffCard } from "../StaffCard/StaffCard";
import StaffLogo from "../../assets/headings/staff.svg";
import HtaHeading from "../../assets/headings/hta.svg";
import StaHeading from "../../assets/headings/sta.svg";
import UtaHeading from "../../assets/headings/uta.svg";
import FullStaff from "../../assets/staff/full-staff.png";
import "./Staff.scss";

const GROUP_HEADINGS: Record<string, { src: string; alt: string }> = {
  "Head Teaching Assistants": {
    src: HtaHeading,
    alt: "Professor and Head Teaching Assistants",
  },
  STAs: { src: StaHeading, alt: "Student Teaching Assistants" },
  "Undergraduate Teaching Assistants": { src: UtaHeading, alt: "Undergraduate Teaching Assistants" },
};

export class Staff extends React.Component<SectionProps> {
  render() {
    return (
      <section className={`staff staff-section ${this.props.static ? "static" : ""}`}>
        <div id="staff">
          <div className="section-heading">
            <img className="staff-logo logo" src={StaffLogo} alt="staff text" />
          </div>
          <div className="staff-roster-wrap">
            <figure className="staff-roster">
              <img src={FullStaff} alt="CS0150 course staff" />
            </figure>
          </div>
          {staffGroups.map((group) => {
            const heading = GROUP_HEADINGS[group.title];
            const featured = group.members.filter((member) => member.role === "Professor");
            const rest = group.members.filter((member) => member.role !== "Professor");
            const gridMembers = featured.length > 0 ? rest : group.members;
            return (
              <div className="staff-group" key={group.title}>
                {heading && (
                  <div className="staff-group-heading">
                    <img src={heading.src} alt={heading.alt} />
                  </div>
                )}
                {featured.map((member) => (
                  <div className="staff-grid staff-grid--solo" key={member.cslogin}>
                    <StaffCard {...member} />
                  </div>
                ))}
                {gridMembers.length > 0 && (
                  <div
                    className={`staff-grid${gridMembers.length === 1 ? " staff-grid--solo" : ""}`}
                  >
                    {gridMembers.map((member) => (
                      <StaffCard key={member.cslogin} {...member} />
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}
